import { useCallback, useEffect, useState } from 'react';
import { useClickAway } from 'react-use';
import { getSelectedBlockNode } from 'libs/common/utils';
import { getNodeOffsetTop, isBlockEmpty as isEmpty, setBlockSelection } from '../util/block';

/**
 * Handle the visibility of the `BlockEditToolbar` given the state of the editor
 */
var useToggleBlockEditToolbar = function useToggleBlockEditToolbar(editorState, containerNode, updateBlockData) {
  var _useState = useState(false),
      isBlockSelected = _useState[0],
      setIsBlockSelected = _useState[1];

  var _useState2 = useState(false),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1];

  var _useState3 = useState({
    top: 0
  }),
      buttonPosition = _useState3[0],
      setButtonPosition = _useState3[1];

  var _useState4 = useState(),
      block = _useState4[0],
      setBlock = _useState4[1];

  var _useState5 = useState(null),
      blockPosition = _useState5[0],
      setBlockPosition = _useState5[1];

  var _useState6 = useState(0),
      nodeOffsetTop = _useState6[0],
      setNodeOffsetTop = _useState6[1];

  var hideToolbar = useCallback(function () {
    setIsVisible(false);
    setIsBlockSelected(false);
  }, []);
  var findCurrentBlockNode = useCallback(function (currentBlock, currentBlockMap) {
    var selectedNode = getSelectedBlockNode(currentBlock, currentBlockMap);

    if (!selectedNode) {
      hideToolbar();
      return;
    }

    var offsetTop = getNodeOffsetTop(editorState, currentBlock, selectedNode);
    setNodeOffsetTop(offsetTop);
  }, [editorState, hideToolbar]);
  useEffect(function () {
    setButtonPosition({
      top: nodeOffsetTop
    });
  }, [nodeOffsetTop]);
  var updateScrollPosition = useCallback(function (bloclkMap) {
    if (block === undefined) {
      return;
    }

    var selectedNode = getSelectedBlockNode(block, bloclkMap);

    if (selectedNode !== null) {
      var diffToScroll = nodeOffsetTop - getNodeOffsetTop(editorState, block, selectedNode);
      window.scrollBy(0, -1 * diffToScroll);
    }
  }, [block, nodeOffsetTop, editorState]);
  var selectBlock = useCallback(function () {
    if (block === undefined) {
      return;
    }

    setIsBlockSelected(true);
    setBlockSelection(editorState, block.getKey(), updateBlockData, true);
  }, [editorState, block, updateBlockData]);
  var unselectBlock = useCallback(function () {
    if (block === undefined) {
      return;
    }

    if (isBlockSelected) {
      setBlockSelection(editorState, block.getKey(), updateBlockData, false);
    }

    setIsBlockSelected(false);
  }, [editorState, block, updateBlockData, isBlockSelected]);
  useClickAway({
    current: containerNode
  }, unselectBlock);
  useEffect(function () {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    var selectedBlock = contentState.getBlockForKey(selectionState.getAnchorKey());
    var selectedBlockKey = selectedBlock.getKey();
    var blockMap = contentState.getBlockMap();
    var selectedBlockPosition = blockMap.toIndexedSeq().findIndex(function (vBlock) {
      return (vBlock === null || vBlock === void 0 ? void 0 : vBlock.getKey()) === (selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.getKey());
    });
    var isSelectionNotEmpty = !selectionState.isCollapsed() || selectionState.getAnchorKey() !== selectionState.getFocusKey();
    var isBlockEmpty = isEmpty(selectedBlock, blockMap);
    var isSelectedBlockChanged = (block === null || block === void 0 ? void 0 : block.getKey()) !== selectedBlockKey;
    var isSelectedBlockPositionChanged = selectedBlockPosition !== blockPosition;
    setBlock(selectedBlock);

    if (isSelectionNotEmpty || isBlockEmpty) {
      hideToolbar();
      return;
    }

    if (isSelectedBlockChanged) {
      setIsVisible(true);
      findCurrentBlockNode(selectedBlock, blockMap);
      setBlockPosition(selectedBlockPosition);
      return;
    }

    if (isSelectedBlockPositionChanged) {
      updateScrollPosition(blockMap);
      findCurrentBlockNode(selectedBlock, blockMap);
      setBlockPosition(selectedBlockPosition);
    }
  }, [editorState, block, findCurrentBlockNode, hideToolbar, setIsVisible, blockPosition, updateScrollPosition]);
  return {
    block: block,
    isBlockSelected: isBlockSelected,
    isVisible: isVisible,
    buttonPosition: buttonPosition,
    selectBlock: selectBlock,
    unselectBlock: unselectBlock
  };
};

export default useToggleBlockEditToolbar;